import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
const SvgLogoText = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 44,
	height: 44,
	viewBox: "0 0 44 44",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		id: "text favicon",
		filter: "url(#filter0_d_12227_95604)",
		children: [/* @__PURE__ */ _jsx("rect", {
			id: "Rectangle 975",
			x: 6,
			y: 4,
			width: 32,
			height: 32,
			rx: 4
		}), /* @__PURE__ */ _jsxs("g", {
			id: "t|",
			children: [/* @__PURE__ */ _jsx("path", {
				d: "M20.1764 25.5714H21.8127V23.6565H20.8553C20.2286 23.6565 20.0023 23.4128 20.0023 22.821V18.4341H21.9346V16.5193H20.0023V14.0473H17.6174V16.5193H16.3292V18.4341H17.6174V22.995C17.6174 24.5966 18.4356 25.5714 20.1764 25.5714Z",
				fill: "#0F0F10"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M24.3389 28.1826H26.3582V11.645H24.3389V28.1826Z",
				fill: "#0F0F10"
			})]
		})]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("filter", {
		id: "filter0_d_12227_95604",
		x: 0,
		y: 0,
		width: 44,
		height: 44,
		filterUnits: "userSpaceOnUse",
		colorInterpolationFilters: "sRGB",
		children: [
			/* @__PURE__ */ _jsx("feFlood", {
				floodOpacity: 0,
				result: "BackgroundImageFix"
			}),
			/* @__PURE__ */ _jsx("feColorMatrix", {
				in: "SourceAlpha",
				type: "matrix",
				values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
				result: "hardAlpha"
			}),
			/* @__PURE__ */ _jsx("feOffset", { dy: 2 }),
			/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 3 }),
			/* @__PURE__ */ _jsx("feColorMatrix", {
				type: "matrix",
				values: "0 0 0 0 0.0745098 0 0 0 0 0.0745098 0 0 0 0 0.0901961 0 0 0 0.2 0"
			}),
			/* @__PURE__ */ _jsx("feBlend", {
				mode: "normal",
				in2: "BackgroundImageFix",
				result: "effect1_dropShadow_12227_95604"
			}),
			/* @__PURE__ */ _jsx("feBlend", {
				mode: "normal",
				in: "SourceGraphic",
				in2: "effect1_dropShadow_12227_95604",
				result: "shape"
			})
		]
	}) })]
});
export default SvgLogoText;
